import { DownloadSimple, EnvelopeSimple, Link as LinkIcon } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { usePageMeta } from "@/hooks/usePageMeta";
import contentStyles from "./ContentPage.module.css";
import styles from "./Press.module.css";

export function Press() {
  const { t } = useTranslation();
  usePageMeta({
    title: t("pageMeta.pressTitle"),
    description: t("pageMeta.pressDescription"),
  });
  return (
    <article className={contentStyles.page}>
      <header>
        <h1>{t("press.title")}</h1>
        <p className={contentStyles.lead}>{t("press.lead")}</p>
      </header>

      <section>
        <h2>{t("press.pitchTitle")}</h2>
        <p>{t("press.pitchShort")}</p>
        <p>{t("press.pitchLong")}</p>
      </section>

      <section>
        <h2>{t("press.factsTitle")}</h2>
        <ul className={styles.facts}>
          <li>
            <strong>2014</strong>
            <span>{t("press.factFounded")}</span>
          </li>
          <li>
            <strong>{t("press.factEventsNumber")}</strong>
            <span>{t("press.factEvents")}</span>
          </li>
          <li>
            <strong>{t("press.factFreemiumPrice")}</strong>
            <span>{t("press.factFreemium")}</span>
          </li>
          <li>
            <strong>0</strong>
            <span>{t("press.factZero")}</span>
          </li>
          <li>
            <strong>DE</strong>
            <span>{t("press.factHosting")}</span>
          </li>
        </ul>
      </section>

      <section>
        <h2>{t("press.logoTitle")}</h2>
        <p>{t("press.logoBody")}</p>
        <div className={styles.logoGrid}>
          <a className={styles.logoBox} href="/favicon.ico" download>
            <DownloadSimple size={16} weight="regular" />
            favicon.ico
          </a>
          <a className={styles.logoBox} href="/apple-touch-icon.png" download>
            <DownloadSimple size={16} weight="regular" />
            apple-touch-icon.png
          </a>
          <a className={styles.logoBox} href="/og/og-en.png" download>
            <DownloadSimple size={16} weight="regular" />
            og-en.png (1200×630)
          </a>
          <a className={styles.logoBox} href="/og/og-de.png" download>
            <DownloadSimple size={16} weight="regular" />
            og-de.png (1200×630)
          </a>
          <a className={styles.logoBox} href="/og/og-es.png" download>
            <DownloadSimple size={16} weight="regular" />
            og-es.png (1200×630)
          </a>
        </div>
      </section>

      <section>
        <h2>{t("press.contactTitle")}</h2>
        <ul className={styles.contactList}>
          <li>
            <EnvelopeSimple size={18} weight="regular" />
            <a href="mailto:hello@brings-mit.com">hello@brings-mit.com</a>
          </li>
          <li>
            <LinkIcon size={18} weight="regular" />
            <Link to="/imprint">{t("press.imprintLink")}</Link>
          </li>
        </ul>
        <p className={styles.hint}>{t("press.licenseNote")}</p>
      </section>
    </article>
  );
}
